import { ITranslationKey } from '../../ITranslationKey';
import { getNormalizedValue } from '../../translationKeysUtils';
import {
  BaseTranslationSchema,
  ITranslationUpdateContext,
  TranslationSchemaType,
} from './BaseTranslationSchema';

export class TranslationStringSchema extends BaseTranslationSchema {
  type = TranslationSchemaType.String;

  private getKey(value: string, prefix: string) {
    return `${prefix}.${getNormalizedValue(value)}`;
  }

  extract(value: any, path: string, prefix: string): ITranslationKey[] {
    if (!value || typeof value !== 'string' || value.trim() === '') return [];

    return [
      {
        chiave: this.getKey(value, prefix),
        valore: value,
      },
    ];
  }

  translateValue(
    value: any,
    path: string,
    prefix: string,
    ctx: ITranslationUpdateContext,
  ) {
    if (!value) return;
    const key = this.getKey(value, prefix);
    const translation = ctx.translations.get(key);
    ctx.set(path, translation);
  }
}
